import React from 'react';

function getPrettyEventName(rows, fallbackName) {
  const fromMetadata = rows?.[0]?.metadata?.eventName;
  if (fromMetadata && String(fromMetadata).trim()) return fromMetadata;
  return fallbackName || 'Unknown event';
}

function renderStars(rating) {
  const value = Number(rating) || 0;

  return (
    <span style={{ letterSpacing: 1, whiteSpace: 'nowrap' }}>
      {[1, 2, 3, 4, 5].map((n) => (
        <span
          key={n}
          style={{
            color: n <= value ? '#F4C542' : '#D1D5DB',
            fontSize: 16,
          }}
        >
          ★
        </span>
      ))}
    </span>
  );
}

export default function EventExperienceFeedbackTable({
  eventId,
  rows = [],
  fallbackEventName = '',
}) {
  const eventName = getPrettyEventName(rows, fallbackEventName);

  const td = {
    borderBottom: '1px solid #eee',
    padding: '8px',
    verticalAlign: 'top',
    textAlign: 'left',
  };

  const th = {
    ...td,
    fontWeight: 800,
    background: '#fafafa',
    borderTop: '1px solid #eee',
  };

  return (
    <div style={{ marginTop: 10 }}>
      <div style={{ fontWeight: 900, marginBottom: 6 }}>
        {eventName}{' '}
        <span style={{ color: '#6b7280', fontWeight: 600 }}>
          ({rows.length})
        </span>
      </div>

      <div style={{ marginBottom: 8, fontSize: 12, color: '#6b7280' }}>
        Event ID: <code>{eventId}</code>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={th}>User</th>
            <th style={th}>Rating</th>
            <th style={th}>Comment</th>
            <th style={th}>Created</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((fb) => {
            const meta = fb?.metadata || {};
            const comment = meta.anythingElse || fb.message || '';
            const rating = fb.rating ?? meta.rating ?? null;

            return (
              <tr key={fb._id}>
                <td style={td}>
                  {(fb.userName || '').trim() || '(No name)'}
                  {fb.userEmail ? (
                    <div style={{ color: '#6b7280', fontSize: 12 }}>
                      {fb.userEmail}
                    </div>
                  ) : null}
                </td>

                <td style={td}>
                  {rating ? renderStars(rating) : <span style={{ color: '#6b7280' }}>—</span>}
                </td>

                <td style={td}>
                  {comment ? comment : <span style={{ color: '#6b7280' }}>—</span>}
                </td>

                <td style={td}>
                  {fb.createdAt ? new Date(fb.createdAt).toLocaleString() : ''}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}